import { render, staticRenderFns } from "./classify-edit.vue?vue&type=template&id=75d7622c&scoped=true&"
import script from "./classify-edit.vue?vue&type=script&lang=js&"
export * from "./classify-edit.vue?vue&type=script&lang=js&"
import style0 from "./classify-edit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./classify-edit.vue?vue&type=style&index=1&id=75d7622c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d7622c",
  null
  
)

export default component.exports